import './style/App.css';
import { useState } from 'react';
import './style/App.css';
import Header from './include/Header';
import PrestaTarifs from './views/PrestaTarifs';
import Salon from './views/Salon';
import Footer from './include/Footer';

function App() {
  const [view, setView] = useState("salon");
  const [displayNav, setDisplayNav] = useState(false);
  const [tab1, setTab1] = useState("man");
  const [tab2, setTab2] = useState("brushing");
  const [accordion, setAccordion] = useState(1);
  
  const goTo = (newView) => {
    window.scrollTo({ top: 0, left: 0})
    setView(newView);
    setDisplayNav(false);
  };
  const toggleNav = () => {
    setDisplayNav(!displayNav);
  };
  const changeTab = (newTab) => {
    if (newTab === "man" || newTab === "woman") {
      setTab1(newTab);
    } else if (newTab === "brushing" || newTab === "color" || newTab === "balayage" || newTab === "care") {
      setTab2(newTab);
    }
  }
  const expandAccordion = (state) => {
    if (state <= 4 && state > 0) {
      if (accordion === state) {
        if (state === 4) {
          setAccordion(1);
        } else {
          setAccordion(state + 1);
        }
      } else {
        setAccordion(state);
      }
    }
  }

  let RenderView;
  switch (view) {
    case "prestaTarifs":
      RenderView = <PrestaTarifs tab1={tab1} tab2={tab2} changeTab={changeTab}/>
      break;
  
    default:
      RenderView = <Salon expandAccordion={expandAccordion} accordion={accordion}/>
      break;
  }
  
  return (
    <>
      <Header goTo={goTo} toggleNav={toggleNav} displayNav={displayNav} />
      {RenderView}
      <Footer />
    </>
  );
}

export default App;
